<mat-card appearance="outlined">
  <mat-card-content>
    <div class="flex-col">
      @if (loadingIndicator) {
        <mat-progress-bar mode="query"></mat-progress-bar>
      }

      <mat-table [dataSource]="dataSource">

        <ng-container matColumnDef="name">
          <mat-header-cell *matHeaderCellDef > Namn </mat-header-cell>
          <mat-cell *matCellDef="let row" title="{{row.comments}}"> {{row.name}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="score">
          <mat-header-cell *matHeaderCellDef > Bedömning </mat-header-cell>
          <mat-cell *matCellDef="let row"> {{row.score}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="remainingAspects">
          <mat-header-cell *matHeaderCellDef > Återstår </mat-header-cell>
          <mat-cell *matCellDef="let row"> {{row.remainingAspects}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef class="flex-300px justify-center">
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="flex-300px justify-center">
            <button mat-button color="primary" (click)="showDetails($event, row)">Detaljer</button>
            <button mat-button color="accent" (click)="showAspectTexts($event, row)">Aspekter</button>
            <button mat-button  (click)="showProposals($event, row)">Förslag</button>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;">
        </mat-row>
      </mat-table>
    </div>
  </mat-card-content>
</mat-card>

